import React from 'react';
import renderIf from 'render-if';
import Filter from 'components/Filter';
import Divider from 'components/Divider';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './DashboardView.scss';

const DashboardNav = (props) => {
  // eslint-disable-next-line no-unused-vars
  const { tab, toggleSchools, toggleView, toggleFilter, filter, updateFilter, subscribed,
        showSchools } = props;
  const renderIfDefault = renderIf(tab === 0);
  const renderIfContacted = renderIf(tab === 1);
  const renderIfWishList = renderIf(tab === 2);
  const renderIfNotUpgrade = renderIf(true);
  const renderFilterIcon = renderIf(tab === 0);
  return (
    <div className={cn('col s12', styles.removePadding)}>
      <div className={cn('col s12', styles.tabsContainer)}>
        {renderIfDefault(
          <div className={styles.tabsButton}>
            <button
              className={showSchools === true ? styles.colorSchoolTab :
                styles.schoolTab} onClick={() => toggleSchools('school')}
            >
              COLLEGES
            </button>
            <button
              className={showSchools === true ? styles.postingTab
                : styles.colorPostingTab}
              onClick={() => toggleSchools('posting')}
            >POSTINGS
            </button>
          </div>,
        )}
        {renderIfContacted(
          <div className={styles.tabsButton}>
            <span className={styles.myrequestSpan}>
                COACHES YOU HAVE CONTACTED
              </span>
          </div>,
        )}
        {renderIfWishList(
          <div className={styles.tabsButton}>
            <button
              className={styles.schoolTabWithoutBorder}
              onClick={() => this.toggleSchools('school')}
            >SCHOOLS
            </button>
          </div>,
        )}

        {renderIfNotUpgrade(
          <span className={styles.filterButtonsContainer}>
            {renderFilterIcon(
              <button
                className={styles.gridButton}
                onClick={() => toggleFilter()}
              >
                <img alt="filtericon" src="https://media.dev.myrecruitboard.com/Images/filterNormal.png" />
                {/* {this.state.showFilter === false ? */}
                {/* <img alt="filtericon" src="https://media.dev.myrecruitboard.com/Images/filterNormal.png" /> */}
                {/* : */}
                {/* <img */}
                {/* alt="filtericon" */}
                {/* src="https://media.dev.myrecruitboard.com/Images/filterIcon.png" */}
                {/* /> */}
                {/* } */}
              </button>,
              )}
            <button className={styles.gridButton} onClick={toggleView}>
              <img
                alt="filtericon"
                src="https://media.dev.myrecruitboard.com/Images/lineIcon.png"
              />
              {/* {this.state.gridView === true ? */}
              {/* <img */}
              {/* alt="filtericon" */}
              {/* src="https://media.dev.myrecruitboard.com/Images/lineIcon.png" */}
              {/* /> */}
              {/* : */}
              {/* <img alt="filtericon" src="https://media.dev.myrecruitboard.com/Images/gridIcon.png" /> */}

              {/* } */}
            </button>
          </span>)}
      </div>
      <Divider />
      {renderIfDefault(
        <div className={styles.tabsButton}>
          <span className={styles.myrequestSpan}>
                MATCHES BASED ON YOUR ACADEMIC AND BIOMETRIC PROFILES
              </span>
        </div>,
      )}

      <Filter
        updateFilter={updateFilter}
        filter={filter}
        toggleFilter={toggleFilter}
        usedFor="schools"
        {...props}
      />
    </div>
  );
};

DashboardNav.propTypes = {
  tab: PropTypes.number.isRequired,
  toggleSchools: PropTypes.func.isRequired,
  toggleView: PropTypes.func.isRequired,
  toggleFilter: PropTypes.func.isRequired,
  updateFilter: PropTypes.shape.isRequired,
  filter: PropTypes.shape().isRequired,
  subscribed: PropTypes.bool.isRequired,
  showSchools: PropTypes.bool.isRequired,
};

export default DashboardNav;



// WEBPACK FOOTER //
// ./src/components/DashboardView/dashboardnav.js